// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-byazt{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-bynog{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-brlkg{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bbznw{grid-column:span 3}.assets-scss-gridstyleGrid-col4-hkido{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bkhpq{grid-column:span 9}.assets-scss-gridstyleGrid-col12-zkxod{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-mxzji{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-byazt",
	"grid": "assets-scss-gridstyleGrid-grid-bynog",
	"col6": "assets-scss-gridstyleGrid-col6-brlkg",
	"col3": "assets-scss-gridstyleGrid-col3-bbznw",
	"col4": "assets-scss-gridstyleGrid-col4-hkido",
	"col9": "assets-scss-gridstyleGrid-col9-bkhpq",
	"col12": "assets-scss-gridstyleGrid-col12-zkxod",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-mxzji"
};
module.exports = ___CSS_LOADER_EXPORT___;
